export default __webpack_public_path__ + "static/media/icon_sorting-descending.acc9d890.svg";